import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Loading from './components/Loading';

import LoginPage from './pages/Login/LoginPage';
import Layout from './pages/Layout/Layout';
import OrganizationsPage from './pages/Organizations/OrganizationsPage';
import OrganizationDetailPage from './pages/Organizations/OrganizationDetailPage';
import ProfilePage from './pages/Profile/ProfilePage';
import CalendarPage from './pages/Calendar/CalendarPage';
import EventsPage from './pages/Events/EventsPage';
import FeedbackPage from './pages/Feedback/FeedbackPage';
import BoardsPage from './pages/Boards/BoardsPage';
import UsersPage from './pages/Users/UsersPage';
import MembersPage from './pages/Members/MembersPage';
import LogsPage from './pages/Logs/LogsPage';
import ActivityPage from './pages/Activity/ActivityPage';
import OutfitPage from './pages/Outfit/OutfitPage';
import DocumentsPage from './pages/Documents/DocumentsPage';
import DiscordPage from './pages/Discord/DiscordPage';
import AdminDiscordPage from './pages/AdminDiscord/AdminDiscordPage';

function ProtectedRoute({ children, roles, permission }) {
  const { user, loading } = useAuth();
  if (loading) return <Loading />;
  if (!user) return <Navigate to="/login" />;
  if (roles && !roles.includes(user.role)) {
    if (!permission || !user.permissions?.[permission]) return <Navigate to="/" />;
  }
  return children;
}

function AppRoutes() {
  const { user, loading } = useAuth();

  if (loading) return <Loading />;

  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" /> : <LoginPage />} />
      <Route path="/" element={
        <ProtectedRoute>
          <Layout />
        </ProtectedRoute>
      }>
        <Route index element={<OrganizationsPage />} />
        <Route path="org/:orgId" element={<OrganizationDetailPage />} />
        <Route path="profile" element={<ProfilePage />} />
        <Route path="org/:orgId/calendar" element={<CalendarPage />} />
        <Route path="org/:orgId/events" element={<EventsPage />} />
        <Route path="org/:orgId/feedback" element={<FeedbackPage />} />
        <Route path="org/:orgId/boards" element={<BoardsPage />} />
        <Route path="org/:orgId/outfit" element={<OutfitPage />} />
        <Route path="org/:orgId/documents" element={<DocumentsPage />} />
        <Route path="org/:orgId/discord" element={<DiscordPage />} />
        <Route path="users" element={
          <ProtectedRoute roles={['admin']}>
            <UsersPage />
          </ProtectedRoute>
        } />
        <Route path="logs" element={
          <ProtectedRoute roles={['admin']}>
            <LogsPage />
          </ProtectedRoute>
        } />
        <Route path="activity" element={
          <ProtectedRoute roles={['admin']}>
            <ActivityPage />
          </ProtectedRoute>
        } />
        <Route path="admin-discord" element={
          <ProtectedRoute roles={['admin']} permission="adminDiscord">
            <AdminDiscordPage />
          </ProtectedRoute>
        } />
        <Route path="members" element={
          <ProtectedRoute roles={['owner', 'leader']}>
            <MembersPage />
          </ProtectedRoute>
        } />
      </Route>
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
